const urlPattern = /^((http|https|ftp):\/\/)/;

export function hasUrlPattern(string) {
    return new RegExp(urlPattern).test(string);
}
